module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1515-bb28de8ec04aaed62a8c6ea099f3354e.jpg";